import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button, Collapse, Nav, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from "reactstrap";
import { ReactComponent as CsLangIcon } from "../assets/CZ.svg";
import { ReactComponent as EnLangIcon } from "../assets/GB.svg";
import { useLanguage } from "../localization/LanguageContext";
import "./MainNavbar.css";

const MD_BREAKPOINT = 768;

function MainNavbar({ className, ...rest })
{
    const [isOpen, setIsOpen] = useState(false);
    const [isMdUp, setIsMdUp] = useState(
        typeof window !== "undefined" && window.innerWidth >= MD_BREAKPOINT
    );
    const location = useLocation();
    const { translation, language, setLanguage } = useLanguage();

    useEffect(() =>
    {
        const handleResize = () =>
        {
            const mdUp = window.innerWidth >= MD_BREAKPOINT;
            setIsMdUp(mdUp);

            // ensure it's open when entering md+
            if (mdUp)
            {
                setIsOpen(true);
            }
        };

        window.addEventListener("resize", handleResize);
        handleResize(); // initialize on mount

        return () => window.removeEventListener("resize", handleResize);
    }, []);
    
    const switchLang = () => setLanguage(language === "en" ? "cs" : "en");

    const toggle = () =>
    {
        if (!isMdUp)
        {
            setIsOpen(!isOpen);
        }
    };

    useEffect(() =>
    {
        if (!isMdUp)
        {
            setIsOpen(false);
        }
    }, [location.pathname, language, isMdUp])

    return (
        <Navbar {...rest} className={`bg-dark ${className}`} expand="md" dark>
            <NavbarBrand tag={Link} to="/" className="text-white display-1 me-2" style={{fontSize: "1.5rem"}}>
                Dominik Navrátil
            </NavbarBrand>
            <NavbarToggler onClick={toggle} className="ms-auto"/>
            <Collapse navbar isOpen={isOpen}>
                <Nav navbar className="me-md-auto display-1 align-items-start align-items-md-center" style={{fontSize: "1.25rem"}}>
                    <NavItem className="d-none"> {/*TODO*/}
                        <NavLink tag={Link} to="/about-me">
                            {translation("about_me_header")}
                        </NavLink>
                    </NavItem>
                    <NavItem className="d-none ">{/*TODO*/} 
                        <NavLink tag={Link} to="/my-projects">
                            {translation("my_projects_navlink")}
                        </NavLink>
                    </NavItem>
                    <NavItem className="m-1 m-md-0">
                        <Button className="icon-btn" onClick={switchLang} title={translation("switch_language")}>{language === "en" ? <CsLangIcon className="icon"/> : <EnLangIcon className="icon"/>}</Button>
                    </NavItem>
                </Nav>
            </Collapse>
        </Navbar>
    );
}

export default MainNavbar;